// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tz-breadcrumbs__list{list-style-type:none;padding:0}.tz-breadcrumbs__list-item{display:inline-block}.tz-breadcrumbs__list-item:last-of-type .tz-breadcrumbs__divider{display:none}.tz-breadcrumbs__divider{position:relative}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
